import drawnBulletsPagination from "../helpers/drawnBulletsPagination";

class ProductFeatureCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, EffectFade, Pagination }) => {
      const swiperParams = {
        modules: [EffectFade, Pagination],
        slidesPerView: "auto",
        speed: 400,
        effect: "fade",
        fadeEffect: { crossFade: true },
        loop: true,
        pagination: drawnBulletsPagination,
      };

      this.swiper = new Swiper(this, swiperParams);

      // Navigation doesn't work properly with loop and effectfade so we have to do it manually
      this.querySelector("[data-navigation-next]")?.addEventListener(
        "click",
        () => {
          const nextIndex =
            this.swiper.activeIndex + 1 < this.swiper.slides.length
              ? this.swiper.activeIndex + 1
              : 0;
          this.swiper.slideTo(nextIndex);
        }
      );

      this.querySelector("[data-navigation-previous]")?.addEventListener(
        "click",
        () => {
          const nextIndex =
            this.swiper.activeIndex === 0
              ? this.swiper.slides.length - 1
              : this.swiper.activeIndex - 1;
          this.swiper.slideTo(nextIndex);
        }
      );
    });
  }
}

if (!customElements.get("product-feature-carousel")) {
  customElements.define("product-feature-carousel", ProductFeatureCarousel);
}
